import { DateTime } from 'luxon';
import React, { useMemo } from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Indisponibilidade from 'Interface/Indisponibilidades';
import { useRemoverIndisponibilidadeMutation } from 'View/Service/Default/Indisponibilidades';

interface Props {
  dados: Indisponibilidade;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerIndisponibilidade] = useRemoverIndisponibilidadeMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerIndisponibilidade({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  const formato = useMemo(() => {
    if (dados.tipo == 1 || dados.tipo == 3) {
      return DateTime.DATE_SHORT;
    } else {
      return DateTime.DATETIME_SHORT;
    }
  }, [dados]);

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <Link
          to={`/usuarios/editar/${dados.usuario_id}/indisponibilidades/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.inicio
            .data()
            .toLocaleString(formato)}
          {dados.inicio != dados.termino &&
            ` até ${dados.termino
              .data()
              .toLocaleString(formato)}`}
        </Link>
        <small className="text-muted fs-6 d-block">Data</small>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            <div className="badge bg-primary">
              {dados.tipo === 1 && 'Férias'}
              {dados.tipo === 2 && 'Folga'}
              {dados.tipo === 3 && 'Afastamento'}
            </div>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.aprovado === 1 && (
              <Icone nome="check-lg" className="text-success" />
            )}
            {dados.aprovado === 0 && (
              <Icone nome="check-lg" className="text-success" />
            )}
            {dados.aprovado === null && (
              <Icone nome="clock" className="text-info" />
            )}
            <small className="text-muted fs-6 d-block">Status</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.modificado.data().toLocaleString(DateTime.DATETIME_SHORT)}
            <small className="text-muted fs-6 d-block">Modificado em</small>
          </div>
        </div>
        <div className="ms-2 fs-5 text-end">
          <Botao
            icone="trash"
            tema="danger"
            className="ms-5"
            confirmacao="Você tem certeza que deseja remover esse registro? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
